export function initInScope($scope) {
    import('bootstrap-select').then(function () {
        $scope.find('.js-multi-select').each(function () {
            $(this).selectpicker({
                noneSelectedText: $(this).attr('placeholder') || $(this).data('label') || ' '
            });
        });
    });
}